<script setup lang="ts">
import { computed } from 'vue'
import { ConfigProvider } from 'tdesign-vue-next'
import { useI18n } from 'vue-i18n'
import enUS from 'tdesign-vue-next/es/locale/en_US'
import zhCN from 'tdesign-vue-next/es/locale/zh_CN'
import idID from '../shared/locales/tdesign/id_ID'

const { locale } = useI18n()

const tdesignLocale = computed<Record<string, any>>(() => {
  if (locale.value === 'id') return { ...(idID as Record<string, any>) }
  if (locale.value === 'zh') return { ...(zhCN as Record<string, any>) }
  return { ...(enUS as Record<string, any>) }
})
</script>

<template>
  <ConfigProvider :global-config="tdesignLocale">
    <router-view />
  </ConfigProvider>
</template>

<style lang="scss">
// Global styles
</style>
